import { TopicStatusWithButtonSingle } from 'components/elearning/topic-status-with-button-single';
import { Box } from 'components/universal/box';
import { FC } from 'react';
import { Answer, Task } from 'types/elearning';
import { MatchImageWithDescription } from '../match-image-with-description';
import { MatchTextWithDescription } from '../match-text-with-description';
import { MatchTextWithImages } from '../match-text-with-images';
import { PutInCorrectOrderImages } from '../put-in-correct-order-images';
import { QuestionsMultiple } from '../question/questions-multiple';
import { QuestionsSingle } from '../question/questions-single';
import Paragraph from 'components/universal/paragraph';

interface IProps {
    task: Task;
    isChecked: boolean;
    correctAnswer: Answer['correct_answer'];
    background?: string;
    isQuiz: boolean;
    prefix?: string;
}

export const TaskFactory: FC<IProps> = ({ task, isChecked, correctAnswer, background, isQuiz, prefix }) => {
    let TaskComponent = null;
    
    switch (task?.type) {
        case 'challenge_choose_one_answer':
            TaskComponent = QuestionsSingle;
            break;
        case 'challenge_choose_many_answers':
            TaskComponent = QuestionsMultiple;
            break;
        case 'challenge_put_in_correct_order_images':
            TaskComponent = PutInCorrectOrderImages;
            break;
        case 'challenge_match_image_with_description':
            TaskComponent = MatchImageWithDescription;
            break;
        case 'challenge_match_text_with_description':
            TaskComponent = MatchTextWithDescription;
            break;
        case 'challenge_match_text_with_images':
            TaskComponent = MatchTextWithImages;
            break;
        default:
            break;
    }
    
    return (
        <Box className="boxQuestion boxQuestion-with-padding">
            {task['title'] && <><Paragraph fontWeight={700}>{task['title']}</Paragraph> <div className='space24'></div></>}
            {task['description'] && <><Paragraph>{task['description']}</Paragraph> <div className='space24'></div></>}
            <TaskComponent
                task={task}
                isChecked={isChecked}
                correctAnswer={correctAnswer}
                background={background}
                isQuiz={isQuiz}
                prefix={prefix}
            />
            {!isQuiz && <TopicStatusWithButtonSingle task={task} type={task.type} />}
        </Box>
    );
};
